import { createModel } from '@rematch/core';
import { Schedule } from '../../models/schedule';
import {
    shouldUpdateState,
    storeData
} from '../../utils/converter';
import {
    getAllSchedules,
    getSchedules
} from '../../apis/schedule';

export interface State {
    byId: Dictionary<Schedule>; // provider + date + time
    loading: Dictionary<boolean>;
}

export const schedules = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: MixType<Schedule>,
            loadingKey?: string
        ): State => {
            if (shouldUpdateState(data, loadingKey)) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        ...storeData(data, ['providerId', 'date', 'time'])
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getAllSchedulesAsync(date: string) {
            const loadingKey = `-${date}`;
            this.loading(loadingKey, true);
            try {
                const data = await getAllSchedules(date);
                this.update(data, loadingKey);
            } catch (e) {
                window.console.log(e);
                this.loading(loadingKey, false);
            }
        },
        async getSchedulesAsync(payload: { providerId: number, date: string }) {
            const loadingKey = [payload.providerId, payload.date].join('-');
            this.loading(loadingKey, true);
            try {
                const data = await getSchedules(payload.providerId, payload.date);
                this.update(data, loadingKey);
            } catch (e) {
                window.console.log(e);
                this.loading(loadingKey, false);
            }
        }
    })
});
